var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.HotelDescriptionMainText),_vm._v(" "),_c(_setup.HotelDescriptionTerritory),_vm._v(" "),_c(_setup.HotelDescriptionLocation),_vm._v(" "),_c(_setup.HotelDescriptionImportant),_vm._v(" "),_c(_setup.HotelDescriptionFacilities),_vm._v(" "),_c(_setup.HotelDescriptionNote)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }